import{s}from"./node_modules/base-x/src/index.mjs";var e=s("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");export{e as b};
//# sourceMappingURL=index.mjs.map
